import {
	createBookingWithEvent,
	listEvents,
} from '@cocoonspace/sdk-js/domains/events/events'
import { cleanQueryKeyFactories } from '@cocoonspace/shared/utils/clean-query-key-factories'
import { useMutation } from '@tanstack/react-query'

export const BOOKING_KEYS = cleanQueryKeyFactories({
	base: ['booking'] as const,
	findOrCreate: () => [...BOOKING_KEYS.base, 'findOrCreate'] as const,
})

export interface UseBookingFindOrCreateMutationArgs {
	day: string
	start: string
	end: string
	space: string
	type: 'meeting' | 'visit' | 'desk'
	qty?: number
}

export const bookingFindOrCreate = async (
	data: UseBookingFindOrCreateMutationArgs,
) => {
	const events = await listEvents({ status: ['option'] })

	const activeEvent = events.data?.find(
		(event) =>
			event.day === data.day &&
			event.start === data.start &&
			event.end === data.end &&
			event.space?.id === data.space,
	)

	if (activeEvent) {
		return activeEvent
	} else {
		return createBookingWithEvent(data).then((res) => res.data)
	}
}

export const useBookingFindOrCreateMutation = () => {
	return useMutation({
		mutationKey: BOOKING_KEYS.findOrCreate(),
		mutationFn: bookingFindOrCreate,
	})
}
